<style scoped>
  .container{max-width:1200px;margin: auto;position: relative}
  /*.md-bg{background-color:rgb(250,250,250)}*/
  .md-bg{background-color:rgb(235, 235, 235)}
  .OCR-btn{position:fixed;cursor: pointer;right:0;top:50%;margin-top:-40px;height:80px;width:20px;background-color: #45db5e;color: white;text-align: center}
</style>
<template>
  <div>
    <sysHeader></sysHeader>
    <div style="padding:20px;" class="md-bg"></div>
    <div class="md-bg">
      <router-view class="container"/>
      <!--<router-view :class="$route.name!='bigData'&&$route.name!='knowledge'?'container':''"/>-->
    </div>
    <sysFooter></sysFooter>
    <div class="OCR-btn" @click="$store.state.OCRState = true">
      <Icon type="ios-arrow-back" />
      O<br/>C<br/>R<br/>
    </div>
    <OCR></OCR>
  </div>
</template>
<script>
  import sysHeader from "./components/system/sysHeader"
  import sysFooter from "./components/system/sysFooter"
  import OCR from "./components/system/OCR"
  export default {
    name:'mainPage',
    components: {sysHeader, sysFooter,OCR},
    computed:{
      OCRState:{
        get:function () {
          return this.$store.state.OCRState
        },
        set:function (val) {
          this.$store.state.OCRState = val
        }
      }
    },
  }
</script>
